export const global = {
  // 会员卡种对应月份数
  MONTH_NUM: 1,
  SEASON_MONTH_NUM: 3,
  HALF_YEAR_MONTH_NUM: 6,
  YEAR_MONTH_NUM: 12,

  // 服务端规定的会员卡种对应Flag
  Month_PRODUCT_FLAG: 1,
  SEASON_PRODUCT_FLAG: 2,
  HALF_YEAR_PRODUCT_FLAG: 7,
  YEAR_PRODUCT_FLAG: 4,
  MASTER_Month_PRODUCT_FLAG: 200,
  MASTER_SEASON_PRODUCT_FLAG: 201,
  MASTER_HALF_YEAR_PRODUCT_FLAG: 202,
  MASTER_YEAR_PRODUCT_FLAG: 203,
  Month_Auto: 205,

  // 用户状态
  USER_STATUS_VIP: 4,
  USER_STATUS_VIP_EXPIRED: 5,

  // 除服务器规定外的客户端定义的errorCode
  ERROR_CODE_UNDEFINED: 0,
  ERROR_CODE_ACTIVITYID_ERROR: -1, // 运营配置不符合客户端定义要求
  ERROR_CODE_CONFIG_ERROR: -2, // 运营配置不符合客户端定义要求
  ERROR_CODE_UNKNOW_RESULT: -3, // 服务端接口返回值不符合预期
  // 服务端接口对应code
  ERROR_INTERFACE_POSTCOUPON: 1010,
  // 手游产品名字
  30: '月卡',
  90: '季卡',
  180: '半年卡',
  360: '年卡',
  720: '两年卡',

  AUTO_RENEW_FLAG: 'Auto', // 自动续费产品标志

  // 判断livelink 5min 绑定限制的 localStorage flag
  LOCAL_STORAGE_FLAG_BASE: 'lastOperationTime' ,
  // 判断是否弹出过挽留弹窗
  LOCAL_STORAGE_NO_LEAVING: 'noLeaving' 
}

  // 与页面UI字段对应
export const MAIN_PROD_FLAG = {
  ROW: 'row',
  TILE: 'tile',
  SCROLL: 'scroll',
  SCROLLTWO: 'scrolltwo'
}

  // 与portal字段对应
export const MAIN_PROD_DISPLAY_STYLE_MAP =  {
  "1": MAIN_PROD_FLAG.ROW, // 突出
  "2": MAIN_PROD_FLAG.TILE, // 平铺
  "3": MAIN_PROD_FLAG.SCROLL,// 横滑
  "4": MAIN_PROD_FLAG.SCROLLTWO// 横滑2
}

export const DOWNLOAD_URL = {
  ANDROID: 'https://pic.xunyou.mobi/apk/official_m.apk',
  IOS: 'https://www.xunyou.mobi/iOS_app/',
  XMT_ANDROID: 'https://pic.xunmengtu.com/xmtapk/xmt-activity.apk',
  XMT_IOS: 'https://www.xunmengtu.com/iOS_app/',
}